import React from 'react'
import "./layout.scss"
function LayoutPage(props) {
  const { Component } = props
  return (
    <div className='wrapper-container'>
      <Component {...props} />
    </div>
  )
}

export default LayoutPage
